export const AUTH_RETURN_PATH_STORAGE_KEY = 'massal_auth_return_path';

const SAFE_AUTH_RETURN_PATHS = new Set([
  '/',
  '/create-story',
  '/features',
  '/examples',
  '/contact',
  '/privacy',
  '/terms'
]);

const SAFE_AUTH_RETURN_PREFIXES = [
  '/story/'
];

export const isSafeAuthReturnPath = (value = '') => {
  const path = typeof value === 'string' ? value.trim() : '';
  const pathname = path.split(/[?#]/)[0] || '/';

  if (!pathname.startsWith('/') || path.startsWith('//')) {
    return false;
  }

  return SAFE_AUTH_RETURN_PATHS.has(pathname)
    || SAFE_AUTH_RETURN_PREFIXES.some((prefix) => pathname.startsWith(prefix));
};

export const getCurrentAuthReturnPath = (location = {}) => {
  const pathname = typeof location.pathname === 'string' ? location.pathname : '';
  const search = typeof location.search === 'string' ? location.search : '';
  const hash = typeof location.hash === 'string' ? location.hash : '';
  const path = `${pathname}${search}${hash}` || '/';

  return isSafeAuthReturnPath(path) ? path : '/';
};

export const getSafeSessionStorage = (browserWindow) => {
  if (!browserWindow) {
    return null;
  }

  try {
    return browserWindow.sessionStorage || null;
  } catch {
    return null;
  }
};

export const saveAuthReturnPath = (storage, location) => {
  if (!storage) {
    return '';
  }

  const path = getCurrentAuthReturnPath(location);
  try {
    storage.setItem(AUTH_RETURN_PATH_STORAGE_KEY, path);
  } catch {
    return '';
  }

  return path;
};

export const consumeAuthReturnPath = (storage) => {
  if (!storage) {
    return '';
  }

  let value = '';

  try {
    value = storage.getItem(AUTH_RETURN_PATH_STORAGE_KEY) || '';
    storage.removeItem(AUTH_RETURN_PATH_STORAGE_KEY);
  } catch {
    return '';
  }

  return isSafeAuthReturnPath(value) ? value : '';
};

export const peekAuthReturnPath = (storage) => {
  if (!storage) {
    return '';
  }

  let value = '';

  try {
    value = storage.getItem(AUTH_RETURN_PATH_STORAGE_KEY) || '';
  } catch {
    return '';
  }

  return isSafeAuthReturnPath(value) ? value : '';
};
